// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list ion-item ion-radio p,
.item-list ion-item ion-label p {
  margin: 0;
  color: var(--ion-color-medium-shade);
  font-size: 14px;
}

ion-label {
  padding-inline-end: 26px;
}

ion-checkbox {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/popup-search-select/popup-search-select.component.scss"],"names":[],"mappings":"AAIQ;;EACI,SAAA;EACA,oCAAA;EACA,eAAA;AAFZ;;AAOA;EACI,wBAAA;AAJJ;;AAOA;EACI,kBAAA;AAJJ","sourcesContent":[".item-list ion-item {\n\n    ion-radio,\n    ion-label {\n        p {\n            margin: 0;\n            color: var(--ion-color-medium-shade);\n            font-size: 14px;\n        }\n    }\n}\n\nion-label {\n    padding-inline-end: 26px;\n}\n\nion-checkbox {\n    margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
